import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { Msg } from '@app/_components/msg';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { SharedService } from './../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class MsgService {

	statuses: any = [
		{ value: 1, name: 'Draft' },
		{ value: 2, name: 'Sent' },
		{ value: 3, name: 'Received' },
		{ value: 4, name: 'Failed' },
    { value: 5, name: 'Outbox' }
	];
  msgTopics: any = [
    {name: '', value: null },
    {name: 'reservation', value: 100 },
    {name: 'campaign', value: 200 },
    {name: 'imap read', value: 300 },
    {name: 'jobs', value: 400 },
    {name: 'owner profile', value: 500 },
    {name: 'task', value: 600 },
    {name: 'proforma                         ', value: 700 },
    {name: 'website query                    ', value: 800 },
    {name: 'custom mail                      ', value: 900 },
    {name: 'public review                    ', value: 1000},
    {name: 'sent review request              ', value: 1100},
    {name: 'survey guest exit before         ', value: 1200},
    {name: 'created lead profile             ', value: 1300},
    {name: 'inquiry for waikiki hilltop house', value: 1400},
    {name: 'inquiry for influencer           ', value: 1500},
    {name: 'guest communication sms received ', value: 1600},
    {name: 'guest communication send sms     ', value: 1700},
    {name: 'review received notification     ', value: 1800}
  ];
  msgAudiences: any = [
    {name: 'reservation', value: 100 },
    {name: 'campaign', value: 200 },
    {name: 'imap read', value: 300 },
    {name: 'jobs', value: 400 },
    {name: 'owner profile', value: 500 },
    {name: 'task', value: 600 },
    {name: 'bizdev', value: 700 },
    {name: 'public review', value: 1000},
    {name: 'sent review request', value: 1100},
    {name: 'guest communication', value: 1600},
    {name: 'quote', value: 1700},
    {name: 'realtor', value: 510},
    {name: 'owner lead profile', value: 2300},
  ];
  msgTopicPurposes: any = [
    {name: 'reservation', value: 100 },
    {name: 'campaign', value: 200 },
    {name: 'imap_read', value: 300 },
    {name: 'jobs', value: 400 },
    {name: 'owner_profile', value: 500 },
    {name: 'task', value: 600 },
    {name: 'proforma                         ', value: 700 },
    {name: 'website_query                    ', value: 800 },
    {name: 'custom_mail                      ', value: 900 },
    {name: 'public_review                    ', value: 1000},
    {name: 'sent_review_request              ', value: 1100},
    {name: 'survey_guest_exit_before         ', value: 1200},
    {name: 'created_lead_profile             ', value: 1300},
    {name: 'inquiry_for_waikiki_hilltop_house', value: 1400},
    {name: 'inquiry_for_influencer           ', value: 1500},
    {name: 'guest_communication_sms_received ', value: 1600},
    {name: 'guest_communication_send_sms     ', value: 1700},
    {name: 'review_received_notification     ', value: 1800}
  ];
  msgEvents: any = [
    { value: 1, name: 'delivered' },
    { value: 2, name: 'dropped' },
    { value: 3, name: 'deferred' },
    { value: 3, name: 'bounced' },
    { value: 4, name: 'opened' },
    { value: 4, name: 'clicked' },
    { value: 5, name: 'unsubscribed' }
  ];


	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'msgs';

	add(msg: Msg): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(msg));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, msg);
	}
  addWithAttachment(msg: Msg): Observable<ApiResponse> {
    console.log('posting... ' + JSON.stringify(msg));
    let formData = new FormData();
    if( msg?.attachments?.length>0){
      msg.attachments.forEach(file => {
        formData.append('attachments', file);
      });
    }
    msg.attachments = null;
    formData.append('msgAPI', new Blob([JSON
      .stringify(msg)], {
      type: 'application/json'
    }));
    return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/replyMailWithAttachment`, formData);
  }
  addAndSendMail(msg: Msg): Observable<ApiResponse> {
    console.log('posting... ' + JSON.stringify(msg));
    return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/save-and-send-mail`, msg);
  }

  sendMsg(msg: Msg): Observable<ApiResponse> {
    console.log('posting... ' + JSON.stringify(msg));
    return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/v2/sent-msg`, msg);
  }

  sendMsgPerReservation(msgs: any): Observable<ApiResponse> {
    console.log('posting... ' + JSON.stringify(msgs));
    return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/v2/sent-msgs`, msgs);
  }

	update(msg: Msg): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, msg);
	}
  updateTask(msg: Msg): Observable<ApiResponse> {
    return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/update-task`, msg);
  }
  archiveMsg(msg: Msg): Observable<ApiResponse> {
    return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/archive`, msg);
  }

  updateMsgsFolder(msgIds: number[], folder: number): Observable<ApiResponse> {
    return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/v2/update-msgs-folder`, { msgIds, folder });
  }

  updateMsgPriority(msgIds: number[], msgPriority: number): Observable<ApiResponse> {
    return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/v2/update-msgs-priority`, { msgIds, msgPriority });
  }

  getTagsBySource(source: number, sourceIds: number[]): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/tags/by-source`, { source, sourceIds });
  }

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`);
	}
  deleteByMsgCampaignId(msgCampaignId: number): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/bymsgcampaignid/${msgCampaignId}`);
  }

	send(msg: Msg): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(msg));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/sendMail`, msg);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any, msgEvent: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
    let appender = '';
    if ( msgEvent){
      appender = '?msgEvent=' + msgEvent;
    }
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}${appender}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}
  findByTaskId(taskId: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/task/${taskId}`).pipe(retry({ count: 2, delay: 1500 }));
  }

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}


	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
    fetchHistory1(mailId): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/historybyemail/${mailId}`).pipe(retry({ count: 2, delay: 1500 }));

	}
	fetchHistory2(mailId: any): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/historybyemail`, { params: null }).pipe(retry({ count: 2, delay: 1500 }));

	}

  fetchHistory(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/historybyemail`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

  getTopicMessagesRecipient(topic: number, topicId: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(
			`${environment.apiUrl}/${this.urlEndpoint}/v2/get-topic-messages-recepient/${topic}/${topicId}`
		).pipe(retry(1));
	}

  getAttachment(msgId: number, index: number): Observable<Blob> {
    return this.http.get(
      `${environment.apiUrl}/${this.urlEndpoint}/v2/${msgId}/attachments/${index}`,
      { responseType: 'blob' }
    );
  }
}
